import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * GreetingHeading — крупное приветствие (`.hello` макета): 22px / 600. Несёт семантику заголовка.
 */
export interface GreetingHeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2'
}

export const GreetingHeading = forwardRef<HTMLHeadingElement, GreetingHeadingProps>(
  ({ className, as: Tag = 'h1', ...props }, ref) => (
    <Tag ref={ref} className={cn('text-22 font-semibold text-txt', className)} {...props} />
  ),
)
GreetingHeading.displayName = 'GreetingHeading'
